// dependencies
import React from 'react';
import {Link} from 'react-router-dom';

const SearchAgainBtn = () => {
   return (
      <Link to="/">
         <button type="button" className="result-btn">
            Search Again
         </button>
      </Link>
   );
};

export default SearchAgainBtn;
